import angular from 'angular';

angular
  .module('cxSettings')
  .controller('SetPaymentProviderConfirmDialogCtrl', [
    '$element',
    '$scope',
    'close',
    '$window',
    'nrLicenses',
    'paymentProvider',
    'billingPeriod',
    'discountAmount',
    'totalAmount',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    '$q',
    setPaymentProviderConfirmDialogCtrl,
  ]);

function setPaymentProviderConfirmDialogCtrl(
  $element,
  $scope,
  close,
  $window,
  nrLicenses,
  paymentProvider,
  billingPeriod,
  discountAmount,
  totalAmount,
  dataCache,
  resourceFactorySvc,
  flySvc,
  $q,
) {
  var vm = this;
  var resource = resourceFactorySvc.get('company');
  vm.totalAmount = totalAmount;
  vm.nrLicenses = nrLicenses;
  vm.paymentProvider = paymentProvider;
  vm.billingPeriod = billingPeriod;
  vm.discountAmount = discountAmount;
  vm.company = dataCache.getDefaultCompany();
  vm.saving = false;

  vm.saveCompany = function($data, field, showSuccess = true) {
    if (vm.saving) {
      return $q.when('');
    }
    //Validation error
    if (typeof $data === 'undefined') {
      if (vm.errors) {
        for (var error in vm.errors) {
          if (vm.errors.hasOwnProperty(error) && error[0] !== '$') {
            if (vm.errors[error].code) {
              if (vm.errors[error].code === 3000) flySvc.error('msgRequiredField');
              else flySvc.error(vm.errors[error].code, vm.errors[error].parameters, field);
            }
          }
        }
      }
      return $q.when('');
    }

    // if new value = old value do nothing
    if (angular.equals(vm.company[field], $data)) return $q.when(false);

    var model = angular.copy(vm.company);
    model[field] = $data;

    vm.saving = true;
    // put copy to server
    return resource.update(model).$promise.then(
      function(success) {
        // success callback: replace the value in (the field in) company with the new value
        // this is usually 1 field, but when Iban is changed it is 2 fields (iban + bic)
        angular.extend(vm.company, success);

        const dataCacheCompany = dataCache.getArray('company').find(x => x.id == vm.company.id);

        if (dataCacheCompany) {
          angular.extend(dataCacheCompany, $scope.activeCompany);
        }

        if (success.foundInKBO === null || success.foundInKBO === true) {
        } else if (checkTenantConfiguration('[0,1]')) {
          flySvc.message('msgCompanyCBENotFound');
        }
        vm.saving = false;
        return false;
      },
      function(error) {
        vm.saving = false;
        // error callback return error? (edit remains open)
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };

  vm.validate = function() {
    if (!vm.company.enterpriseNumber && !vm.company.kvkNumber) return false;
    if (
      !vm.company.address.street1 ||
      !vm.company.address.zipCode ||
      !vm.company.address.city ||
      !vm.company.address.country
    )
      return false;

    return true;
  };

  vm.submit = function() {
    if (vm.validate()) {
      $element.modal('hide');
      close(true, 500);
    } else {
      flySvc.error('msgRequiredEnterpriseNumberAndAddress');
    }
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
